/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AdjacentExhibitorDto } from '../models/adjacent-exhibitor-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { exhibitorControllerCreateV1 } from '../fn/exhibitor/exhibitor-controller-create-v-1';
import { ExhibitorControllerCreateV1$Params } from '../fn/exhibitor/exhibitor-controller-create-v-1';
import { exhibitorControllerDeleteV1 } from '../fn/exhibitor/exhibitor-controller-delete-v-1';
import { ExhibitorControllerDeleteV1$Params } from '../fn/exhibitor/exhibitor-controller-delete-v-1';
import { exhibitorControllerFindAdjacentV1 } from '../fn/exhibitor/exhibitor-controller-find-adjacent-v-1';
import { ExhibitorControllerFindAdjacentV1$Params } from '../fn/exhibitor/exhibitor-controller-find-adjacent-v-1';
import { exhibitorControllerFindAllV1 } from '../fn/exhibitor/exhibitor-controller-find-all-v-1';
import { ExhibitorControllerFindAllV1$Params } from '../fn/exhibitor/exhibitor-controller-find-all-v-1';
import { exhibitorControllerFindByIdV1 } from '../fn/exhibitor/exhibitor-controller-find-by-id-v-1';
import { ExhibitorControllerFindByIdV1$Params } from '../fn/exhibitor/exhibitor-controller-find-by-id-v-1';
import { exhibitorControllerSearchCursorV1 } from '../fn/exhibitor/exhibitor-controller-search-cursor-v-1';
import { ExhibitorControllerSearchCursorV1$Params } from '../fn/exhibitor/exhibitor-controller-search-cursor-v-1';
import { exhibitorControllerSearchV1 } from '../fn/exhibitor/exhibitor-controller-search-v-1';
import { ExhibitorControllerSearchV1$Params } from '../fn/exhibitor/exhibitor-controller-search-v-1';
import { exhibitorControllerToggleExposedV1 } from '../fn/exhibitor/exhibitor-controller-toggle-exposed-v-1';
import { ExhibitorControllerToggleExposedV1$Params } from '../fn/exhibitor/exhibitor-controller-toggle-exposed-v-1';
import { exhibitorControllerUpdateV1 } from '../fn/exhibitor/exhibitor-controller-update-v-1';
import { ExhibitorControllerUpdateV1$Params } from '../fn/exhibitor/exhibitor-controller-update-v-1';
import { ExhibitorDto } from '../models/exhibitor-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class ExhibitorService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `exhibitorControllerSearchV1()` */
  static readonly ExhibitorControllerSearchV1Path = '/api/v1/exhibitor/search';

  /**
   * 참가업체 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exhibitorControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  exhibitorControllerSearchV1$Response(params?: ExhibitorControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<ExhibitorDto>;
}>> {
    return exhibitorControllerSearchV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 참가업체 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exhibitorControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exhibitorControllerSearchV1(params?: ExhibitorControllerSearchV1$Params, context?: HttpContext): Observable<OffsetPaginationDto & {
'items'?: Array<ExhibitorDto>;
}> {
    return this.exhibitorControllerSearchV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto & {
'items'?: Array<ExhibitorDto>;
}>): OffsetPaginationDto & {
'items'?: Array<ExhibitorDto>;
} => r.body)
    );
  }

  /** Path part for operation `exhibitorControllerSearchCursorV1()` */
  static readonly ExhibitorControllerSearchCursorV1Path = '/api/v1/exhibitor/search/cursor';

  /**
   * 참가업체 커서 기반 검색.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exhibitorControllerSearchCursorV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  exhibitorControllerSearchCursorV1$Response(params?: ExhibitorControllerSearchCursorV1$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<ExhibitorDto>;
}>> {
    return exhibitorControllerSearchCursorV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 참가업체 커서 기반 검색.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exhibitorControllerSearchCursorV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exhibitorControllerSearchCursorV1(params?: ExhibitorControllerSearchCursorV1$Params, context?: HttpContext): Observable<CursorPaginationDto & {
'items'?: Array<ExhibitorDto>;
}> {
    return this.exhibitorControllerSearchCursorV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto & {
'items'?: Array<ExhibitorDto>;
}>): CursorPaginationDto & {
'items'?: Array<ExhibitorDto>;
} => r.body)
    );
  }

  /** Path part for operation `exhibitorControllerFindAllV1()` */
  static readonly ExhibitorControllerFindAllV1Path = '/api/v1/exhibitor';

  /**
   * 모든 참가업체 목록 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exhibitorControllerFindAllV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  exhibitorControllerFindAllV1$Response(params?: ExhibitorControllerFindAllV1$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ExhibitorDto>>> {
    return exhibitorControllerFindAllV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 모든 참가업체 목록 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exhibitorControllerFindAllV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exhibitorControllerFindAllV1(params?: ExhibitorControllerFindAllV1$Params, context?: HttpContext): Observable<Array<ExhibitorDto>> {
    return this.exhibitorControllerFindAllV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ExhibitorDto>>): Array<ExhibitorDto> => r.body)
    );
  }

  /** Path part for operation `exhibitorControllerCreateV1()` */
  static readonly ExhibitorControllerCreateV1Path = '/api/v1/exhibitor';

  /**
   * 참가업체 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exhibitorControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exhibitorControllerCreateV1$Response(params: ExhibitorControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ExhibitorDto>> {
    return exhibitorControllerCreateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 참가업체 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exhibitorControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exhibitorControllerCreateV1(params: ExhibitorControllerCreateV1$Params, context?: HttpContext): Observable<ExhibitorDto> {
    return this.exhibitorControllerCreateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExhibitorDto>): ExhibitorDto => r.body)
    );
  }

  /** Path part for operation `exhibitorControllerFindAdjacentV1()` */
  static readonly ExhibitorControllerFindAdjacentV1Path = '/api/v1/exhibitor/{id}/adjacent';

  /**
   * 이전글/다음글 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exhibitorControllerFindAdjacentV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  exhibitorControllerFindAdjacentV1$Response(params: ExhibitorControllerFindAdjacentV1$Params, context?: HttpContext): Observable<StrictHttpResponse<AdjacentExhibitorDto>> {
    return exhibitorControllerFindAdjacentV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 이전글/다음글 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exhibitorControllerFindAdjacentV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exhibitorControllerFindAdjacentV1(params: ExhibitorControllerFindAdjacentV1$Params, context?: HttpContext): Observable<AdjacentExhibitorDto> {
    return this.exhibitorControllerFindAdjacentV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<AdjacentExhibitorDto>): AdjacentExhibitorDto => r.body)
    );
  }

  /** Path part for operation `exhibitorControllerFindByIdV1()` */
  static readonly ExhibitorControllerFindByIdV1Path = '/api/v1/exhibitor/{id}';

  /**
   * 참가업체 ID로 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exhibitorControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  exhibitorControllerFindByIdV1$Response(params: ExhibitorControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ExhibitorDto>> {
    return exhibitorControllerFindByIdV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 참가업체 ID로 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exhibitorControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exhibitorControllerFindByIdV1(params: ExhibitorControllerFindByIdV1$Params, context?: HttpContext): Observable<ExhibitorDto> {
    return this.exhibitorControllerFindByIdV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExhibitorDto>): ExhibitorDto => r.body)
    );
  }

  /** Path part for operation `exhibitorControllerDeleteV1()` */
  static readonly ExhibitorControllerDeleteV1Path = '/api/v1/exhibitor/{id}';

  /**
   * 참가업체 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exhibitorControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  exhibitorControllerDeleteV1$Response(params: ExhibitorControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return exhibitorControllerDeleteV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 참가업체 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exhibitorControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exhibitorControllerDeleteV1(params: ExhibitorControllerDeleteV1$Params, context?: HttpContext): Observable<boolean> {
    return this.exhibitorControllerDeleteV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `exhibitorControllerUpdateV1()` */
  static readonly ExhibitorControllerUpdateV1Path = '/api/v1/exhibitor/{id}';

  /**
   * 참가업체 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exhibitorControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exhibitorControllerUpdateV1$Response(params: ExhibitorControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ExhibitorDto>> {
    return exhibitorControllerUpdateV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 참가업체 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exhibitorControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exhibitorControllerUpdateV1(params: ExhibitorControllerUpdateV1$Params, context?: HttpContext): Observable<ExhibitorDto> {
    return this.exhibitorControllerUpdateV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<ExhibitorDto>): ExhibitorDto => r.body)
    );
  }

  /** Path part for operation `exhibitorControllerToggleExposedV1()` */
  static readonly ExhibitorControllerToggleExposedV1Path = '/api/v1/exhibitor/{id}/expose';

  /**
   * 참가업체 노출/노출해제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exhibitorControllerToggleExposedV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  exhibitorControllerToggleExposedV1$Response(params: ExhibitorControllerToggleExposedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    return exhibitorControllerToggleExposedV1(this.http, this.rootUrl, params, context);
  }

  /**
   * 참가업체 노출/노출해제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exhibitorControllerToggleExposedV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exhibitorControllerToggleExposedV1(params: ExhibitorControllerToggleExposedV1$Params, context?: HttpContext): Observable<boolean> {
    return this.exhibitorControllerToggleExposedV1$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
